/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';

import ClickableElement from '../../ClickableElement';
import { INTRO_HINT_SELECTORS } from '../../common/Intro';
import { actions as logoutAction } from '../../../redux/auth/logout';
import { IDS } from '../../../constants/ids';
import Icon from '../../Icon';
import styles from '../index.styl';

const mapDispatchToProps = {
  logout: logoutAction.send,
};

@connect(
  null,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class Header extends PureComponent {
  static propTypes = {
    logout: PropTypes.func,
    text: PropTypes.string,
  };

  @autobind
  handleLogout() {
    this.props.logout();
  }

  render() {
    return (
      <div styleName="item" className="logout-btn">
        <ClickableElement
          id={IDS.NAV_BAR.LOG_OUT}
          onClick={this.handleLogout}
          className={`ph3 ${INTRO_HINT_SELECTORS.common.logout}`}
          styleName="link"
          ariaLabel="logout"
        >
          <Icon
            name="log-out"
            size={24}
            style={{ transform: 'rotate(180deg)' }}
          />
          <If condition={this.props.text}>
            <span className="pl2">{this.props.text}</span>
          </If>
        </ClickableElement>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/LogoutBtn.jsx